import Component from '../component';

export default class ModalForm extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$formElement = this.$element.find('.modalForm');
    this.$formSubmit = this.$element.find('.modalForm-submit');
    this.$formContent = this.$element.find('.modalForm-content');
    this.$overlayElements = this.$element.find('.modalForm-overlay');

    this.$noticeBox = this.$element.find('.alertBox--notice');
    this.$alertBox = this.$element.find('.alertBox--alert');
    this.$wrapper = $('.wrapper');

    this.formWasSuccessful = false;
    this.formWasErroneus = false;
  }

  bindEvents() {
    this.handleModalShow = this.handleModalShow.bind(this);
    this.handleModalHide = this.handleModalHide.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleFormBefore = this.handleFormBefore.bind(this);
    this.handleFormComplete = this.handleFormComplete.bind(this);
    this.handleFormSuccess = this.handleFormSuccess.bind(this);
    this.handleFormError = this.handleFormError.bind(this);

    this.$element.on('show.bs.modal.modalForm', this.handleModalShow);
    this.$element.on('hide.bs.modal.modalForm', this.handleModalHide);

    this.$formSubmit.on('click.modalForm', this.handleFormSubmit);

    this.$formElement.on('ajax:before.modalForm', this.handleFormBefore);
    this.$formElement.on('ajax:complete.modalForm', this.handleFormComplete);
    this.$formElement.on('ajax:success.modalForm', this.handleFormSuccess);
    this.$formElement.on('ajax:error.modalForm', this.handleFormError);
  }

  unbindEvents() {
    this.$element.off('show.bs.modal.modalForm', this.handleModalShow);
    this.$element.off('hide.bs.modal.modalForm', this.handleModalHide);

    this.$formSubmit.off('click.modalForm', this.handleFormSubmit);

    this.$formElement.off('ajax:before.modalForm', this.handleFormBefore);
    this.$formElement.off('ajax:complete.modalForm', this.handleFormComplete);
    this.$formElement.off('ajax:success.modalForm', this.handleFormSuccess);
    this.$formElement.off('ajax:error.modalForm', this.handleFormError);
  }

  handleFormBefore() {
    this.$overlayElements.show();
  }

  handleFormComplete() {
    this.$overlayElements.hide();
  }

  handleFormSubmit() {
    this.$formElement.submit();
  }

  handleFormSuccess() {
    this.formWasSuccessful = true;

    this.$alertBox.hide();
    this.$noticeBox.show();

    this.$formSubmit.hide();
    this.$formContent.hide();
  }

  handleFormError() {
    this.formWasErroneus = true;

    this.$noticeBox.hide();
    this.$alertBox.show();
  }

  handleModalShow() {
    this.$noticeBox.hide();
    this.$alertBox.hide();

    this.$formSubmit.show();
    this.$formContent.show();

    this.disableWrapperOverflowScroll();
  }

  handleModalHide() {
    this.enableWrapperOverflowScroll();
  }

  display() {
    this.$element.modal();
  }

  disableWrapperOverflowScroll() {
    if (!navigator.userAgent.match(/iPhone|iPad|iPod/i)) return;

    this.$wrapper.css({
      '-webkit-overflow-scrolling': 'unset',
    });
  }

  enableWrapperOverflowScroll() {
    if (!navigator.userAgent.match(/iPhone|iPad|iPod/i)) return;

    this.$wrapper.css({
      '-webkit-overflow-scrolling': 'touch',
    });
  }
}
